import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { AppState } from '../../../../state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { getTurno } from 'src/app/utils';
import { ReporteData, Turno } from 'src/app/models';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TipoVehiculoService } from 'src/app/services/tipo-vehiculo.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reporte-turno',
  templateUrl: './reporte-turno.component.html',
  styleUrls: ['./reporte-turno.component.scss']
})
export class ReporteTurnoComponent implements OnInit {
  public formBusqueda:FormGroup; //formulario de busqueda
  rows: ReporteData = null;
  colums = [{ name: 'NO. BOLETO' }, { name: 'TURNO' }, { name: 'CARRIL' }, { name: 'FECHA CRUCE' },
            { name: 'HORA CRUCE'}, { name: 'COBRADOR' } , { name: 'TIPO VEHICULO' }, { name: 'TARIFA'}];
  ColumnMode = ColumnMode;
  loadingIndicator : boolean = false;
  turnoActual:Turno;
  tiposVehiculo:any = [];
  turnos:any[] = [];
  carriles:any[] = [];
  turnosNames = {
    1: 'NOCTURNO',
    2: 'MATUTINO',
    3: 'VESPERTINO'
  }
  cobradores:any[] = [];
  totalDineroCobrado:number = 0;
  constructor(private formBuilder: FormBuilder,
              private reporteService:ReporteriaService,
              private toastr:ToastrService,
              private store: Store<AppState>,
              private ngxUiLoaderService:NgxUiLoaderService,
              private vehiculoService:TipoVehiculoService) {  }

  async ngOnInit() {
    this.turnoActual = getTurno(); // { id: 1: name: Matutino}
    this.getTipoVehiculo();
    this.createForm();
    await this.getData();

  }

  createForm(){
    this.formBusqueda =  this.formBuilder.group({
      turno: [''],
      fecha: [''], 
      cobrador:[''],
      carriles: [''],
      vehiculos: ['']
     });

     this.formBusqueda.get('fecha').setValue(moment().format('YYYY-MM-DD'));//fecha actual
     this.formBusqueda.get('turno').setValue(this.turnoActual.id);//selected turno actual
  }

   async getData() {
    this.ngxUiLoaderService.start('1');
    let caseta = this.getCasetaUser(); // Obtener caseta de usuario logeado
    await Promise.all([this.reporteService.getTurnos(), this.reporteService.getCarriles(caseta.id), this.reporteService.getCobradores()]) //get data [turnos,carriles]
    .then(results => {
      this.turnos = results[0];
      this.carriles = results[1];
      this.cobradores = results[2];
      this.ngxUiLoaderService.stop('1');
    }).catch(error => {
      console.log(`Error en alguna promise:${error}`);
    });
   }

   getTipoVehiculo(){
    this.vehiculoService.getClasificacionVehiculo()
    .subscribe(resultado => {
      this.tiposVehiculo = resultado;
    });
   }

   getCasetaUser(){
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
   }


  // consumir api
  searchData() {
    this.loadingIndicator = true;
    let form = { ...this.formBusqueda.value, 'tipoReporte': 1 };
    this.reporteService.getDataReporte(1, form)//numero pagina , formData
    .subscribe(boletos => {
         this.loadingIndicator = false;
         console.log(boletos.data);
         this.rows = boletos;
         this.calcularTotal();
    });
  }

  setPage(event){
   this.loadingIndicator = true;
   let page = event.offset + 1;
   this.reporteService.getDataReporte(page, { ...this.formBusqueda.value, 'tipoReporte': 1})
   .subscribe(boletos => {
      console.log(boletos.data);
      this.rows = boletos;
      this.loadingIndicator = false;
      this.calcularTotal();
    });
  }

  calcularTotal(){
    this.totalDineroCobrado = 0;
    this.rows.data.forEach(boleto => {
       console.log(boleto);
       this.totalDineroCobrado += parseFloat(boleto.monto); 
       console.log(this.totalDineroCobrado);
    });
  }

   //Exportar excel
   exportFileExcel(){
    this.ngxUiLoaderService.start('2');
    let urlExcel:string;
    this.reporteService.descargarArchivo( {...this.formBusqueda.value, 'tipoReporte': 1})
    .then((file:Blob) => {
        let urlDownload = this.reporteService.downloadExcel(file,`reporte_turno_${moment().format('YYYY-MM-DD')}.xlsx`);
        if(urlDownload != ''){
          urlExcel = urlDownload;
          this.ngxUiLoaderService.stop('2');
          return this.toastr.success('Se ha descargado con éxito el archivo Excel', '', { positionClass: 'toast-bottom-right' })  
        }
    })
    .catch(error => {
      console.log(error);
      this.ngxUiLoaderService.stop('2');
      return this.toastr.error(`Por favor intenta de nuevo, ${error}`, 'Error al descargar', { positionClass: 'toast-bottom-right' })
    })
    .finally(() => {
      URL.revokeObjectURL(urlExcel);
    });
 }

}
